import { rem } from 'polished';
import styled from 'styled-components';

import { gradient } from './../../styles';

const colors = {
  shadow: '16, 24, 40,',
  shadow_match: '13, 3, 0,',
};

const sizes = {
  gutter: 8,
  gutter_834: 12,
};

export const Wrapper = styled.p`
  width: 100%;
  aspect-ratio: 1 / 1;
  position: relative;
  margin: 0;
  border-radius: ${rem(12)};
  box-sizing: border-box;
  overflow: hidden;
  box-shadow:
    0 ${rem(24)} ${rem(48)} -${rem(12)} rgba(${colors.shadow} 0.15),
    0 ${rem(8)} ${rem(16)} -${rem(4)} rgba(${colors.shadow} 0.2);

  .img-wrapper {
    width: 100%;
    height: 100%;
    display: block;
    overflow: hidden;

    img,
    svg {
      width: 100%;
      height: auto;
      display: block;
    }

    img {
      object-fit: cover;
    }

    svg {
      background: ${({ theme }) =>
        theme.colors.book.practitioners.avatar.background};
      padding: ${rem(15)};
      box-sizing: border-box;
    }
  }

  .tag {
    background: ${({ theme }) =>
      theme.colors.book.practitioners.tag.background};
    position: absolute;
    left: ${rem(sizes.gutter)};
    bottom: ${rem(sizes.gutter)};
    padding: ${rem(4)};
    border-radius: ${rem(6)};
    z-index: 10;

    &.top-match {
      ${gradient};
      bottom: auto;
      top: ${rem(sizes.gutter)};
    }

    svg {
      margin-right: ${rem(3)};
    }

    span {
      font-weight: 500;
    }
  }

  &.match {
    ${gradient};
    padding: ${rem(4)};
    box-shadow:
      0 ${rem(4)} ${rem(8)} -${rem(2)} rgba(${colors.shadow_match} 0.1),
      0 ${rem(8)} ${rem(16)} -${rem(4)} rgba(${colors.shadow_match} 0.2);

    .img-wrapper {
      border-radius: ${rem(10)};
    }
  }

  @media screen and (min-width: 834px) {
    .tag {
      left: ${rem(sizes.gutter_834)};
      bottom: ${rem(sizes.gutter_834)};

      &.top-match {
        bottom: auto;
        top: ${rem(sizes.gutter_834)};
      }
    }
  }
`;
